<script>
export default {
  name: 'DateDivider',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex justify-center gap-3 mb-2">
    <span class="capitalize bg-grey-50 rounded-full px-2 py-0.5 text-sm text-grey-500 font-medium">
      {{ label }}
    </span>
  </div>
</template>

<style scoped></style>
